import { createStore } from 'vuex'
import Claim from './modules/Claim'
import Loss from './modules/Loss'

export default createStore({
	modules: {
		Claim,
		Loss,
	},
	state: {
		login: false,
		ClaimNumber: null,
		message: {
			visibe: false,
			color: 'success',
			timeout: 5000,
			title: null,
			subtitle: null,
			text: 'Message',
		},
	},
	getters: {
		login(state) {
			return state.login
		},
		ClaimNumber(state) {
			return state.ClaimNumber
		},
		message(state) {
			return state.message
		},
	},
	mutations: {
		login(state, data) {
			state.login = data
		},
		ClaimNumber(state, data) {
			state.ClaimNumber = data
		},
		message(state, data) {
			state.message = data
		},
	},
	actions: {
		setLogin(context, data) {
			context.commit('login', data)
		},
		setClaimNumber(context, data) {
			context.commit('ClaimNumber', data)
		},

		showMessage(context, data) {
			//console.log('showMessage', 'data', data)

			//context.commit('ClaimNumber', data)
			let message = context.getters.message;

			//console.log('showMessage', 'data', data)
			//console.log('showMessage', 'status', data.status)

			let status = data?.status

			//Informational responses
			if(status >= 100 && status <= 199)	message.color = 'info'
			// Successful responses
			if(status >= 200 && status <= 299) 	message.color = 'success'
			// Redirection messages
			if(status >= 300 && status <= 399)  message.color = 'success'
			// Client error responses
			if(status >= 400 && status <= 499)  message.color = 'error'
			// Server error responses
			if(status >= 500 && status <= 599)  message.color = 'error'


			if(data?.response?.data?.detail) {
				message.text = data.response.data.detail
			}

			let errorMessage = data?.errorMessage
			if(errorMessage) {
				message.color = 'error'
				message.text = errorMessage
			}

			message.visibe = true

			//console.log('showMessage', 'message', message)
		},
	},
})
